const zhCh = {
    fullStop: '。',
    clickToView: '点击查看',
    // 首页 s
    redTips: '【阅读提示】',
    thankUseApp: '感谢您使用云中飞睡眠！',
    sketchAllAgreement:
        '我们以概要的形式向您直观说明我们如何处理和保护您的个人信息，我们按照产品功能和使用场景梳理、归类了个人信息收集和使用情况，点击以下链接可了解相关信息说明：',
    personalInformation: '已收集个人信息清单',
    sdkList: '第三方SDK列表',
    appJurisdictionExplain: '应用权限说明',
    vvflvSleepPolicy: '云中飞睡眠隐私政策',
    vvflvSleepPolicyMessage1:
        '我们深知个人信息对您的重要性，也感谢您对我们的信任。我们将通过本政策向您说明我们会如何收集、存储、保护、使用及对外提供您的信息，并说明您享有的权利，其中要点如下：',
    vvflvSleepPolicyMessage2:
        '为了让您便于了解您在使用我们的产品和/或服务时，我们需要收集的信息类型与用途，我们将结合具体产品和/或服务向您说明。',
    vvflvSleepPolicyMessage3:
        '为了向您提供服务所需，我们会按照合法、正当、必要的原则收集您的信息。',
    vvflvSleepPolicyMessage4:
        '如果为了向您提供服务而需要将您的信息与第三方共享，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意或确认第三方已经征得您的同意。',
    vvflvSleepPolicyMessage5:
        '如果为了向您提供服务而需要从第三方获取您的信息，我们将要求第三方说明信息来源，并要求第三方保障其提供信息的合法性。',
    vvflvSleepPolicyMessage6:
        '如果我们将信息用于本政策未载明的其他用途、将基于特定目的收集而来的信息用于其他目的时，或我们开展业务需进行的个人信息处理行为超出您原本向第三方提供个人信息时的授权范围，会事先征求您的明确同意。',
    vvflvSleepPolicyMessage7:
        '您可以通过本政策介绍的方式访问和管理您的信息、设置功能、注销帐号或进行投诉举报。',
    vvflvSleepPolicyMessage8: '您可以根据以下索引阅读相应章节，进一步了解本政策的具体内容：',
    policy1: '一、引言',
    policy2: '二、我们如何收集和使用您的个人信息',
    policy3: '三、我们如何访问和管理自己的信息',
    policy4: '四、信息披露',
    policy5: '五、我们如何使用信息和保护您的信息安全',
    policy6: '六、我们如何使用COOKIES或同类技术',
    policy7: '七、我们如何保护未成年人的个人信息',
    policy8: '八、第三方SDK所收集的信息',
    policy9: '九、账号注销',
    policy10: '十、本隐私政策的更改',
    policy11: '十一、联系、投诉及举报',
    policy1Message1:
        '云中飞睡眠App是由深圳云中飞电子有限公司（以下简称“云中飞睡眠”或称“我们”）为您提供的一款智能睡眠监测服务产品。我们深知个人信息对您的重要性，您的信任对我们非常重要。我们将根据相关法律法规要求并参照行业最佳实践为您的个人信息安全提供充分保障，遵循隐私保护原则制订本《隐私政策》（以下简称“本政策”）本政策仅适用于云中飞睡眠App 收集、使用、共享、存储和保护您的个人信息。如您对政策有任何疑问，可按照本政策列明方式与云中飞睡眠取得联系。',
    policy1Message2:
        '当您点击确认同意本政策，即表示您已充分阅读、理解且接受本政策的全部内容，如果您不同意本政策，您应立即停止使用我们提供的产品或服务。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解，本政策对您及云中飞睡眠均具有法律约束力。',
    policy2Message1:
        '1.我们依据法律法规以及遵循正当、合法、必要的原则而收集和使用您在使用服务过程中主动提供或由于产品或服务需要而产生的个人信息。如果我们欲将您的个人信息用于本隐私政策未载明的其它用途，或基于特定目的将收集而来的信息用于其他目的，我们会及时以合理的方式向您告知，并在使用前再次征得您的同意。',
    policy2Message2:
        '2.我们产品与/或服务的核心业务功能所必需的信息：此类信息为产品与/或服务正常运行的必备信息，您须授权我们收集。如您拒绝提供，您将无法正常使用我们的产品与/或服务。',
    policy2Message3: '3.注册账号',
    policy2Message3_1:
        '1）当您注册云中飞睡眠账号时，会向我们提供手机号码、验证码。当您使用第三方账号登录时，我们会读取您在第三方账号注册使用的昵称、头像。目前我们支持手机号码、qq、微信、AppleID、Facebook、邮箱登录方式，后续注册登录方式如有变化，以我们实际提供的为准。',
    policy2Message3_2:
        '2）在您注册我们账号时，我们收集您的账户昵称、性别、出生日期、身高、体重、手机号码、验证码匹配结果、邮箱、您在云中飞睡眠自行设置的邮箱密码等信息。您应悉知，手机号码和验证码匹配结果属于您的个人敏感信息，我们手机该类信息是为了满足相关法律法规的要求，如您拒绝可能导致您无法使用我们的此功能。',
    policy2Message3_3:
        '3）若您以第三方平台的账号（微信账号、AppleID登录，Facebook）登录我们，我们会向第三方请求获取您的个人信息（包括：用户名、账号昵称、头像、手机号码，具体以您授权内容为准）我们还会收集您的国际移动用户识别码IMSI、Android ID用于判断您上次登录云中飞的方式，目的是方便您使用一键登录功能。如果您不提供这些信息，则您无法注册/登录我们产品，且无法使用需注册/登录的功能，但不会影响您正常使用无需注册/登录的功能。',
    policy2Message3_4:
        '4）为实现本平台的基本业务功能 ，如手机号码、第三方注册登录我们使用了MobTech短信/认证等服务，此产品的隐私策略条款，可以参考：http://www.mob.com/about/policy',
    policy2Message4: '4.设备信息',
    policy2Message4_1:
        '我们会收集您访问我们的服务所使用的设备的信息，包括：硬件和软件信息，例如：IP 地址、设备 ID 和类型、特定设备和应用程序设置和特征、应用程序崩溃、广告 ID（例如 Google 的 AAID 和 Apple 的 IDFA，它们都是随机生成的数字，您可以通过您设备的设置功能进行重置）、浏览器类型、版本和语言、操作系统、时区、与 cookie 或其他可以确定您的具体设备或浏览器的技术相关的标识符（例如，IMEI/UDID 和 MAC 地址等信息）。当您使用我们的服务或查看由我们提供的内容时我们会自动收集某些信息并存储在日志中，如服务的访问时间、访问次数、访问ip、事件信息（如错误、崩溃、重启、升级）等',
    policy2Message_up_4_1:
        '1）我们会收集您访问我们的服务所使用的设备的信息，包括：硬件和软件信息，例如：IP 地址、设备 ID 和类型、特定设备和应用程序设置和特征、应用程序崩溃、广告 ID（例如 Google 的 AAID 和 Apple 的 IDFA，它们都是随机生成的数字，您可以通过您设备的设置功能进行重置）、浏览器类型、版本和语言、操作系统、时区、与 cookie 或其他可以确定您的具体设备或浏览器的技术相关的标识符（例如，IMEI/UDID 和 MAC 地址等信息）。当您使用我们的服务或查看由我们提供的内容时我们会自动收集某些信息并存储在日志中，如服务的访问时间、访问次数、访问ip、事件信息（如错误、崩溃、重启、升级）等。',
    policy2Message_up_4_2: '2）获得您同意后的地理位置信息。',
    policy2Message_up_4_3:
        '3）获得您同意后的设备信息，包括设备品牌、设备型号、设备操作系统及版本号、分辨率、像素密度、运营商、唯一设备识别码IDFA(本项仅限iOS系统开发)、MAC地址、GPS地理位置或IP地址(在您未开启GPS地理位置授权时，我们会通过您的IP地址以及利用traceroute跟踪您的IP节点以获取您的所在城市（此项仅限iOS系统开发)）、唯一设备识别码IMEI）。',
    policy2Message_up_4_4: '4）我们需要获取您当前的设备联网状态及网络环境，包括wifi和非wifi。',
    policy2Message5: '5.产品使用信息',
    policy2Message5_1:
        '1）当您选择通过云中飞睡眠同步数据时，我们将收集与您的睡眠习惯有关的数据，这些数据也可能包含您的个人数据（是否吸烟、是否饮酒、饮食偏好、工作类型），可做为云中飞睡眠 和睡眠研究的使用情况。',
    policy2Message5_2:
        '2）您存储在服务器的内容。如您上传到云空间的内容会存储在数据服务提供方服务器，以实现您快速访问和同一内容在不同设备间的共享。我们或合作方不会查看您存储在合作方服务器的内容，我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。',
    policy2Message6: '6.功能点及其对应权限',
    policy2Message6_1:
        '1）睡眠数据同步、记录仪、助眠，需要用到存储读写权限、麦克风录音权限、扬声器权限，位置信息（网络定位）和精准位置（GPS）信息。当您通过蓝牙连接智能设备如（智能喉部按摩器）时，可能需要您授权使用位置信息，以保证您的手机可以快速和智能设备配对并连接成功。',
    policy2Message6_2:
        '2）相机和相册权限：当您设置您的个人头像的时候，需要您授权使用您的相机相册权限，用来拍摄头像或者是在相册中选择图片。',
    policy2Message6_3:
        '3）联系人信息：当您搜索添加好友的时候，您可以授权使用您的联系人信息，方便您快速找到自己的好友。如果您拒绝我们收集关于联系人的信息，我们将不会收集这一信息。',
    policy2Message6_4: '4）网络信息：您的无线和移动网络连接的信息，例如您的服务提供商和信号强度。',
    policy2Message6_5:
        '5）设备传感器信息：为了保证记录仪功能的准确性，需要授权使用设备传感器的基本数据信息，如加速度计等传感器信息。',
    policy2Message6_6: '6）读取/写入存储',
    policy2Message6_6_1:
        '在您睡眠监测（记录仪）过程中，需要将记录仪的音频文件写入到您的手机存储中。',
    policy2Message6_6_2: '如您拒绝提供上述权限将可能导致您无法使用我们的产品、技术及/或服务。',
    policy2Message7:
        '7.为提高您使用我们提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防因钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入、违法违规内容而产生的安全风险，更准确地识别违反法律法规或我们制定的相关协议规则的情况，我们可能使用或整合您的账号信息、设备信息、位置信息、日志信息、安装的应用列表以及我们取得您授权或依据法律共享的信息，来综合判断您账号及交易风险、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。',
    policy2Message7_1: '1) 设备信息',
    policy2Message7_1_1:
        '您的设备及软件相关信息，例如您的设备品牌及型号、IP地址、设备软件版本信息、设备识别码（IMEI/MAC地址/Android ID/OPENUDID、SIM卡IMSI信息、OAID）、位置信息、网络使用习惯、硬件序列号ESN。',
    policy2Message7_2: '2) 日志信息',
    /* eslint-disable */
    policy2Message7_2_1:
        '当您使用我们的产品和/或服务时，我们会收集您对我们服务的详细使用情况，作为有关网络日志保存，包括：IP地址、浏览器的类型、访问的社交媒体页面url地址、访问日期和时间、系统的错误日志及您访问的网页记录。',
    policy3Message1:
        '1.云中飞睡眠收集的有关您的信息和资料将保存在云中飞睡眠 及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或云中飞睡眠 收集信息和资料所在地的境外并在境外被访问、存储和展示。',
    policy3Message2:
        '2.云中飞睡眠 帐号均有安全保护功能，请妥善保管您的用户名及密码信息。云中飞睡眠 将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。',
    policy3Message3:
        '3.在使用我们的网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是云中飞睡眠App的用户名及密码发生泄露，请您立即联络云中飞睡眠客服，以便云中飞睡眠 采取相应措施',
    policy3Message4:
        '4.我们会对员工进行数据安全的意识培养和安全能力的培训和考核，加强员工对于保护个人信息重要性的认识。我们会对处理个人信息的员工进行身份认证及权限控制，并会与接触您个人信息的员工签署保密协议，明确岗位职责及行为准则，确保只有授权人员才可访问个人信息。对于违规员工，我们会严格按照公司内部管理制度及相关法律法规规定追究法律责任。',
    policy3Message5:
        '5.您可以通过手机“设置”-“应用信息”“云中飞睡眠”-“权限”选择禁止地理位置权限、蓝牙权限、相机权限、相册权限、麦克风权限、悬浮窗权限、存储权限、电话权限（此项仅限Android系统开发），以此来撤回您的授权。',
    policy3Message5_2:
        '请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务和功能，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。',
    policy3Message6:
        '6.如您需要获取您向我们提供的个人信息以及我们通过本政策约定收集您的个人信息，请您通过本政策列明的联系方式与我们取得联系并提出此项需求，我们将在15个工作日内处理您的请求。',
    policy4Message0:
        '在如下情况下，云中飞睡眠将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：',
    policy4Message1: '1.经您事先同意，向第三方披露；',
    policy4Message2: '2.为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；',
    policy4Message3:
        '3.根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；',
    policy4Message4:
        '4.如您出现违反中国有关法律、法规或者云中飞睡眠 服务协议或相关规则的情况，需要向第三方披露；',
    policy4Message5:
        '5.如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；',
    policy4Message6:
        '6.在云中飞睡眠 应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，云中飞睡眠 有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。',
    policy4Message7: '7.其它云中飞睡眠 根据法律、法规或者网站政策认为合适的披露。',
    policy5Message1:
        '1.我们使用您的信息的主要原因是提供和改进我们的服务。此外，我们会使用您的信息来帮助您保持安全。管理您的帐户并向您提供我们的服务，分析您的个人资料和其他用户的个人资料，帮助您更好的使用我们的产品服务。',
    policy5Message2:
        '2.您在使用过程中可以连接您使用的我们多个产品设备，以便您可以在所有设备上享受一致的服务体验。我们实现这一点的方式是当您在不同设备登录帐户时连接设备和浏览器数据，或使用部分或全部 IP 地址、浏览器版本或关于您的设备的类似数据，以识别和连接不同设备。',
    policy5Message3:
        '3.改善我们的服务并开发新服务，对用户行为进行研究和分析，以改善我们的服务和内容（例如，我们可能决定根据用户的行为改变外观和感觉，甚至大幅度修改特定功能）开发新的功能和服务（例如，我们可能决定针对用户提出的请求创建新的基于兴趣的功能）。',
    policy5Message4:
        '4.防止、检测和打击欺诈或其他非法或未经授权的活动.处理平台上下正在进行或涉嫌的违规行为，进行数据分析以更好地理解和设计针对这些活动的对策，保留与欺诈活动相关的数据以防止再次发生欺诈，确保符合法律，遵守法律要求，协助执法，执行或行使我们的权利，在大多数情况下，我们处理您的信息的原因是执行您与我们签订的合同。例如，在您使用我们的服务建立有意义的联系时，我们会使用您的信息来维护您的帐户和个人资料，以便其他用户可以看到您的信息和向您推荐其他用户。',
    policy5Message5:
        '5.我们可以在我们有相应合法利益的情况下使用您的信息。例如，我们为不断改进我们的服务而分析用户使用我们的服务的行为，以及我们出于管理、欺诈检测和其他合法目的处理信息。',
    policy5Message6:
        '6.我们努力保护您的个人信息免遭未经授权的访问或更改、泄露或破坏。和所有技术公司一样，虽然我们采取措施保护您的信息，但我们不能保证、您也不能期望您的个人信息始终是安全的。我们会定期监控我们的系统以发现可能存在的漏洞和攻击，并定期审核我们的信息收集、存储和处理做法，以更新我们的物理、技术和组织安全措施。如果我们怀疑或发现任何破坏安全的行为，我们可能会不经通知暂停您使用全部或部分服务的权利。',
    policy6Message0:
        'Cookie和同类技术是互联网中普遍使用的技术。当您使用云中飞睡眠及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符、缓存，以收集和存储您访问、使用本产品时的信息。我们承诺不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie、缓存和同类技术主要为了实现以下功能或服务：',
    policy6Message1:
        '1、我们可能会使用Cookie和缓存技术存储您的登录状态和基本信息作为其他功能的基础，以避免重复手动登录，减少服务请求。',
    policy6Message2:
        '2、我们可能会使用Cookie和缓存技术对图片、音频等多媒体资源文件进行预加载和缓存，以减少网络资源浪费，同时提升您的用户体验。',
    // policy7Message0_1:
    //     '我们非常重视对未成年人的个人信息保护。如您为了未成年人，我们要求您请您的父母或其他监护人仔细阅读本隐私信息保护政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。',
    // policy7Message0_2:
    //     '若您是儿童的父母或其他监护人，请您关注您监护的儿童是否是在取得您的授权同意之后使用我们的服务。如您对您所监护的儿童的个人信息有疑问，请通过本协议中的联系方式与我们联系。',
    policy7Message1_1:
        '1. 根据现行有效的法律法规等相关规定，我们将不满14周岁的未成年人均视为儿童。如您为14周岁以下未成年人，请您的父母或监护人阅读本政策，并在征得您父母或监护人同意的前提下使用我们的服务或向我们提供您的信息。',
    policy7Message2_1:
        '2.如您的父母或监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。',
    policy7Message3_1:
        '3.对于我们提供的儿童成长记录等涉及儿童个人信息的功能或服务，需经父母或监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童的权益所必要的情况下使用或公开披露此信息。',
    policy7Message4_1:
        '4.如果我们发现存在未事先获得可证实的父母或监护人同意的情况下收集了儿童的个人信息，则会尽快删除或匿名化处理相关数据。',
    policy7Message5_1:
        '5.若您是未成年人的父母或监护人，当您对您所监护的未成年人使用我们的产品和或服务或其向我们提供的信息有任何疑问时，请您及时与我们联系，我们将根据国家相关法律法规及本政策的规定保护未成年人的信息。',
    policy8Message0_1:
        '我们会向您告知共享的目的、数据接收方的合法性、并事先征得您的同意。准确记录和保存您个人信息的共享的情况，包括共享的日期、规模、目的，以及数据接收方的基本情况。',
    policy8Message1_1: '1.我们不会与其他任何公司、组织和个人共享您的个人信息，但以下情况除外：',
    policy8Message1_1_1: '（1）事先获得您明确的同意或授权',
    policy8Message1_1_2:
        '（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；',
    policy8Message1_1_3:
        '（3）在法律法规允许的范围内，为维护云中飞睡眠、云中飞睡眠的关联方或合作伙伴、您或其他云中飞睡眠用户或社会公众利益、财产或安全免遭损害而有必要提供；',
    policy8Message1_1_4: '（4）应您需求为您处理您与他人的纠纷或争议；',
    policy8Message1_1_5: '（5）基于学术研究而使用；',
    policy8Message2_0:
        '2.当您使用我们的功能或服务时，在某些特定使用场景下，可能会使用具有相应业务资质及能力的第三方服务商提供的软件服务工具包（简称“SDK”）来为您提供服务，有第三方服务商收集您的必要信息。具体包括以下几种：',
    policy8Message2_1_1: '（1）友盟SDK',
    policy8Message2_1_2: '功能：用于统计、分析数据，提供基础反作弊能力、设备应用性能监控服务',
    policy8Message2_1_3:
        '收集个人信息类型或权限：设备信息及粗略位置（IMEI/MAC地址/Android ID/IDFA/OpenUDID/SIM卡IMSI/IP）、手机状态权限、SDK/API/JS代码版本、浏览器、互联网服务提供商、平台、时间戳、应用程序版本、应用分发渠道、设备型号、传感器参数、终端制造厂商、终端设备操作系统版本、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等、获取运行中的进程信息。',
    policy8Message2_1_4: 'SDK主体：友盟同欣（北京）科技有限公司',
    policy8Message2_1_5: 'https://www.umeng.com/page/policy',
    policy8Message2_2_1: '(2)极光推送 SDK',
    policy8Message2_2_2: '功能：消息推送服务,分享',
    policy8Message2_2_3:
        '收集个人信息类型或权限：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM 卡 IMSI 信息等）网络信息与位置信息（IP地址，WiFi信息，基站信息等相关信息）',
    policy8Message2_2_4: 'SDK主体：深圳市和讯华谷信息技术有限公司',
    policy8Message2_2_5: 'https://www.jiguang.cn/license/privacy',
    policy8Message2_3_1: '（3）微信SDK',
    policy8Message2_3_2: '功能：第三方登录、分享',
    policy8Message2_3_3:
        '收集个人信息类型或权限：服务日志信息、设备信息（包括设备型号、操作系统版本、唯一设备标识符（IMEI、MAC、Android ID、IDFA（iOS独有）、电池、信号强度信息）、软件信息（包括安装应用列表、软件的版本号、浏览器类型）、IP地址、位置信息（基于iOS系统还会通过IP地址、GPS、WLAN（如WIFI）或基站。等途径获取地理位置信息）、用户在分享时主动选择的图片或内容、微信头像、昵称信息。',
    policy8Message2_3_4: 'SDK主体：深圳市腾讯计算机系统有限公司',
    policy8Message2_3_5:
        'https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy',
    policy8Message2_4_1: '（4）QQSDK',
    policy8Message2_4_2: '功能：第三方登录、分享',
    policy8Message2_4_3:
        '收集个人信息类型或权限：操作系统信息、设备型号信息、剪切板信息（适用于iOS）、内存卡权限（适用于Android）、应用列表信息。',
    policy8Message2_4_4: 'SDK主体：深圳市腾讯计算机系统有限公司',
    policy8Message2_4_5:
        'https://wiki.connect.qq.com/qq%E4%BA%92%E8%81%94sdk%E9%9A%90%E7%A7%81%E4%BF%9D%E6%8A%A4%E5%A3%B0%E6%98%8E',
    policy8Message2_5_1: '（5）BuglySDK',
    policy8Message2_5_2: '功能：收集闪退信息，判断、收集、统计crash信息',
    policy8Message2_5_3:
        '收集个人信息类型或权限：日志信息（包括第三方开发者自定义日志、Logcat日志以及APP崩溃堆栈信息）、设备ID（包括Android ID,Open UDID,MAC,IMEI）、iOS广告标识符（IDFA）、终端设备操作系统版本、终端制造厂商、联网信息、系统名称、系统版本以及国家码。',
    policy8Message2_5_4: 'SDK主体：深圳市腾讯计算机系统有限公司',
    policy8Message2_5_5: 'https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56',
    policy8Message2_6_1: '（6）阿里云OSS对象存储SDK',
    policy8Message2_6_2: '功能：上传图片、缓存数据',
    policy8Message2_6_3:
        '收集个人信息类型或权限：允许联网、获取网络状态、判断网络状态、获取本地存储。',
    policy8Message2_6_4: 'SDK主体：北京阿里巴巴云计算计算有限公司',
    policy8Message2_6_5:
        'http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.26104712.J_9220772140.82.1b234373s9nrSI',
    policy8Message2_7_1: '（7）高德地图',
    policy8Message2_7_2: '功能：获取定位',
    policy8Message2_7_3:
        '收集个人信息类型或权限：硬件型号、操作系统版本、设备配置、唯一设备标识符（IMEI、Android ID、OPENUDID、GUID、OAID、MEID）、硬件序列号、网络设备硬件地址MAC、设备连接信息以及设备状态信息、网络身份标识信息，广告标识符IDFA (iOS14.5及以上不收集IDFA）、IP地址、位置信息、定位权限（获取动态位置信息（IP地址、卫星信号、及能够提供相关信息的其他传感器（如可能会为高德提供附近设备、WLAN接入点和基站的信息）））、硬件序列号及其他设备相关信息）、应用信息（应用崩溃信息、通知开关状态、应用安装列表及其他应用相关信息）、设备网络环境信息（IP地址、WiFi信息，基站信息及其他网络相关信息）、IMSI。',
    policy8Message2_7_4: 'SDK主体：高德软件有限公司',
    policy8Message2_7_5: 'https://developer.amap.com/news/privacy_adjustment',
    policy8Message2_8_1: '（8）ShareSDK',
    policy8Message2_8_2: '功能：社交分享',
    policy8Message2_8_3:
        '收集个人信息类型或权限：系统运行信息、网络状态信息、iOS广告标识符（IDFA）、国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI）、应用列表信息、基站信息、社交平台OpenID、地理位置',
    policy8Message2_8_4: 'SDK主体：上海游昆信息技术有限公司',
    policy8Message2_8_5: 'https://www.mob.com/about/policy',
    policy8Message2_9_1: '（9）Facebook Common Android SDK',
    policy8Message2_9_2: '功能：第三方登录',
    policy8Message2_9_3:
        '收集个人信息类型或权限：操作系统信息、设备型号信息、剪切板信息（适用于iOS）、内存卡权限（适用于Android）、应用列表信息。',
    policy8Message2_9_4: 'SDK主体：Facebook',
    policy8Message2_9_5: '暂无协议',
    policy8Message2_10_1: '（10）腾讯开放平台SDK',
    policy8Message2_10_2: '功能：APP前台运行时，获取SIM序列号',
    policy8Message2_10_3:
        '收集个人信息类型或权限：用于提供手机号码登录服务。采集地理位置甄别分享通道，提供反作弊服务。采集设备标识符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM卡序列号)以及手机号码',
    policy8Message2_10_4: 'SDK主体：腾讯开放平台SDK',
    policy8Message2_10_5: 'https://privacy.qq.com/policy/tencent-privacypolicy',
    policy8Message2_11_1: '（11）com.tencent.connect',
    policy8Message2_11_2: '功能：APP前台运行时，获取已安装APP信息',
    policy8Message2_11_3:
        '收集个人信息类型或权限：为了保障您的账号安全和系统安全，我们需要获取您的设备MAC地址、IMSI、Android ID、IP地址、硬件型号、操作系统版本号、唯一设备标识符（IMEI等）、网络设备硬件地址（MAC）、软件版本号、网络接入方式、类型、状态、网络质量数据、操作日志、硬件序列号、服务日志信息，收集运行中的进程，已安装应用列表等行为。',
    policy8Message2_11_4: 'SDK主体：com.tencent.connect',
    policy8Message2_11_5: 'https://privacy.qq.com/policy/tencent-privacypolicy',
    //
    //
    //
    policy9Message0_1:
        '您可以自主要求（我- 账号与安全 - 注销账号）注销账号。在您注销您的账号之前，我们将验证您的个人身份、安全状态、常用设备等信息。您注销账号的行为是不可逆的行为，一旦您注销您的账号，我们将不再收集您的个人信息，并即刻删除有关您账户的一切信息或使其匿名化处理，并保证这些信息不会泄露，同时，您也无法通过已注销的账户获得我们产品的服务。',
    policy10Message1:
        '1.如果决定更改隐私政策，我们会在本政策中、本公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。',
    policy10Message2:
        '2.本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。',
    policy11Message0_1:
        '如果您对本隐私政策有任何疑问、意见或建议，或者对我们收集、使用或披露您的个人信息 有任何问题，请拨打我们的客服电话 400-805-8192或登录深圳市云中飞电子有限公司官网 https://www.vvfly.cn与我们联系。',
    policy11Message1:
        '1.如果您在使用云中飞睡眠产品/服务过程中发现您的信息被用于违法行为或受到侵害，欢迎您进行积极举报，我们将按照《中华人民共和国网络安全法》、《个人信息保护法》等法律的要求受理，您需提供合法有效的权利证明、侵权事实、身份证明等文件以供我们核实，我们将在15个工作日内回复您处理结果，您还可以向网信部门、工信部门、公安及工商等监管部门进行投诉或举报。举报途径如下：',
    policy11Message1_1: '(1)客服电话 400-805-8192',
    policy11Message1_2: '(2)举报邮箱：fly@vvfly.cn',
    policy11Message1_3: '(3)登录深圳市云中飞电子有限公司官网 https://www.vvfly.cn与我们联系。',
    takeeEffect1: '本声明自更新之日起生效',
    takeeEffect2: '深圳市南山区科技南十二路长虹科技大厦2103-04',
    takeeEffect3: '深圳市云中飞电子有限公司',
    takeeEffect4: '最近的更新日期：2023年 6月 20日',
    // 首页 e
    // 人信息清单 s
    vvflyInformationList: '云中飞睡眠个人信息清单',
    orderNumber: '序号',
    useScenarios: '使用场景',
    purpose: '使用目的',
    infoType: '信息种类',
    loginRegistration: '登录注册',
    infoList1_1_1: '通过手机号登录/注册',
    infoList1_1_2: '验证身份',
    infoList1_1_3: '手机号码',
    infoList1_2_1: '通过邮箱登录/注册',
    infoList1_2_3: '邮箱',
    infoList1_3_1: '通过微信登录/注册',
    infoList1_3_3:
        '微信账号、昵称、头像、性别、所在国家、省市信息（请以授权登录界面显示的信息未准）',
    infoList1_4_1: '通过QQ登录/注册',
    infoList1_4_3: 'QQ账号、昵称、头像、性别、所在国家、省市信息（请以授权登录界面显示的信息未准）',
    infoList1_5_1: '通过AppleID登录/注册',
    infoList1_5_3:
        'Apple ID、昵称、头像、性别、所在国家、省市信息（请以授权登录界面显示的信息未准）',
    infoList1_6_1: 'Facebook ID 登录/注册',
    infoList1_6_3:
        'Facebook ID、昵称、头像、性别、所在国家、省市信息（请以授权登录界面显示的信息未准）',
    infoList1_7_1: '游客登录',
    infoList1_7_3: '国际移动用户识别码IMSI、Android ID',
    accountInfo: '账号信息',
    infoList2_1_1: '账号信息',
    infoList2_1_2: '打鼾预测，根据用户生活习惯评估用户使用设备设置档位大小。',
    infoList2_1_3: '昵称、性别、出生日期、身高、体重',
    infoList2_2_1: '生活习惯',
    infoList2_2_3: '是否吸烟、是否饮酒、饮食偏好、工作类型（久坐、久站、重体力工作、其他）',
    infoList2_3_1: '通知提醒设置',
    infoList2_3_2: '及时收到推送消息及提醒（用户互动通知、闹钟提醒、上新活动推送等）',
    infoList2_3_3: '通知权限',
    devSleep: '止鼾器、记录仪和助眠',
    infoList3_1_1: '止鼾器功能',
    infoList3_1_2: '连接并使用止鼾器设备',
    infoList3_1_3: '蓝牙权限、位置权限、存储权限',
    infoList3_2_1: '止鼾器设置功能',
    infoList3_2_2: '连接止鼾器设置干预档位、灵敏度、延时干预功能',
    infoList3_2_3: '蓝牙权限、存储权限',
    infoList3_3_1: '止鼾器',
    infoList3_3_2: '同步数据，并生成睡眠报告，分享睡眠报告',
    infoList3_3_3: '蓝牙权限，分享数据（第三方微信、朋友圈、QQ,Facebook）',
    infoList3_4_1: '记录仪',
    infoList3_4_2: '设置闹钟、手机记录整晚睡眠情况',
    infoList3_4_3: '麦克风权限、存储权限，悬浮窗权限',
    infoList3_5_1: '记录仪设置',
    infoList3_5_2: '鼾声上传，用户分析用户的整晚睡眠情况',
    infoList3_5_3: '存储权限、麦克风权限',
    infoList3_6_1: '助眠音乐',
    infoList3_6_2: '提供助眠音乐',
    infoList3_6_3: '阿里云服务下载',
    infoList4_0_1: '发现',
    infoList4_0_2: '提供咨询健康信息展示',
    infoList4_0_3: '浏览、收藏、点赞、分享、关注行为信息，网络环境（wifi和非wifi）',
    infoList5_0_1: '数据缓存',
    infoList5_0_2: '快速访问',
    infoList5_0_3: '数据权限',
    infoList6_0_1: '调用终端设备信息',
    infoList6_0_2: '保障设备安全',
    infoList6_0_3:
        '设备信息：设备品牌及型号、IP地址、设备软件版本信息、电话权限（获取IMEI）、设备识别码(MAC/Android ID/OPENUDID、SIM卡IMSI信息、OAID)、位置信息、硬件序列号ESN。\n' +
        ' 日志信息：搜索查询内容（如搜索词语）、IP地址、浏览器的类型、访问的社交媒体页面url地址、访问日期和时间、系统的错误日志及您访问的网页记录',
    infoList7_0_1: '调用手机信息',
    infoList7_0_2: '验证身份，账号安全登录',
    infoList7_0_3:
        '登录时我们还需要收集您的 硬件序列号、唯一设备识别码（android_id、Mac地址、IMEI、IMSI,SIM卡序列号） ，为了保障软件与服务的安全运行、运营的质量及效率，我们会收集你的设备的硬件型号、操作系统版本号、设备标识符（Android如IMEI、AndroidID、OAID、IMSI、ICCID、MEID、硬件序列号）、网络设备硬件地址（MAC地址）、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、设备传感器数据。',
    infoList8_0_1: 'APP前台运行时',
    infoList8_0_2: 'SIM卡序列号',
    infoList8_0_3:
        '在您注册/登录账户时，您需要提供 手机号码及验证码 ，使用App服务时，您需提供 手机号码 作为账户登录名，登录时我们还需要收集您的 硬件序列号、唯一设备识别码（android_id、Mac地址、IMEI、IMSI,SIM卡序列号） 以验证账号及密码并完成登录；如您拒绝提供 手机号码、验证码及密码 个人信息，则可能无法成功注册/登录App账户。',
    // 人信息清单 e

    // sdk 列表 s
    vvflySdkTitle: '云中飞睡眠与第三方共享个人信息清单',
    otherSdkList: '第三方SDK列表',
    // orderNumber 序号
    sdkName: 'SDK名称',
    sdkCompany: 'SDK主体',
    // purpose: '使用目的'
    collectInfoType: '收集个人信息类型',
    privacyLink: '隐私政策链接',
    sdk1_1: '友盟SDK',
    sdk1_2: '友盟同欣（北京）科技有限公司',
    sdk1_3: '用于统计、分析数据，提供基础反作息弊能力，设备应用性能监控服务',
    sdk1_4: '设备信息及粗略位置（IMEI/MAC地址/Android ID/IDFA/OpenUDID/SIM卡IMSI/IP）、手机状态权限、SDK/API/JS代码版本、浏览器、互联网服务提供商、平台、时间戳、应用程序版本、应用分发渠道、设备型号、传感器参数、终端制造厂商、终端设备操作系统版本、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等。',
    sdk2_1: '极光推送 SDK',
    sdk2_2: '深圳市和讯华谷信息技术有限公司',
    sdk2_3: '消息推送服务,分享',
    sdk2_4: '设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM 卡 IMSI 信息等）网络信息与位置信息（IP地址，WiFi信息，基站信息等相关信息）',
    sdk3_1: '微信SDK',
    sdk3_2: '深圳市腾讯计算机系统有限公司',
    sdk3_3: '第三方登录、分享',
    sdk3_4: '服务日志信息、设备信息（包括设备型号、操作系统版本、唯一设备标识符（IMEI、MAC、Android ID、IDFA（iOS独有）、电池、信号强度信息）、软件信息（包括安装应用列表、软件的版本号、浏览器类型）、IP地址、位置信息（基于iOS系统还会通过IP地址、GPS、WLAN（如WIFI）或基站。等途径获取地理位置信息）、用户在分享时主动选择的图片或内容、微信头像、昵称信息。',
    sdk4_1: 'QQSDK',
    sdk4_2: '深圳市腾讯计算机系统有限公司',
    sdk4_3: '第三方登录、分享',
    sdk4_4: '操作系统信息、设备型号信息、剪切板信息（适用于iOS）、内存卡权限（适用于Android）、应用列表信息。',
    sdk5_1: 'BuglySDK',
    sdk5_2: '深圳市腾讯计算机系统有限公司',
    sdk5_3: '收集闪退信息，判断、收集、统计crash信息',
    sdk5_4: '日志信息（包括第三方开发者自定义日志、Logcat日志以及APP崩溃堆栈信息）、设备ID（包括Android ID,Open UDID,MAC,IMEI）、iOS广告标识符（IDFA）、终端设备操作系统版本、终端制造厂商、联网信息、系统名称、系统版本以及国家码。',
    sdk6_1: '阿里云OSS对象存储SDK',
    sdk6_2: '北京阿里巴巴云计算计算有限公司',
    sdk6_3: '上传图片、缓存数据',
    sdk6_4: '允许联网、获取网络状态、判断网络状态、获取本地存储。',
    sdk7_1: '高德地图',
    sdk7_2: '高德软件有限公司',
    sdk7_3: '获取定位',
    sdk7_4: '硬件型号、操作系统版本、设备配置、唯一设备标识符（IMEI、Android ID、OPENUDID、GUID、OAID、MEID）、硬件序列号、网络设备硬件地址MAC、设备连接信息以及设备状态信息、网络身份标识信息，广告标识符IDFA (iOS14.5及以上不收集IDFA）、IP地址、位置信息、定位权限（获取动态位置信息（IP地址、卫星信号、及能够提供相关信息的其他传感器（如可能会为高德提供附近设备、WLAN接入点和基站的信息）））、硬件序列号及其他设备相关信息）、应用信息（应用崩溃信息、通知开关状态、应用安装列表及其他应用相关信息）、设备网络环境信息（IP地址、WiFi信息，基站信息及其他网络相关信息）、IMSI。',
    sdk8_1: 'ShareSDK',
    sdk8_2: '上海游昆信息技术有限公司',
    sdk8_3: '社交分享',
    sdk8_4: '系统运行信息、网络状态信息、iOS广告标识符（IDFA）、国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI）、应用列表信息、基站信息、社交平台OpenID、地理位置',
    sdk9_1: 'Facebook Common Android SDK',
    sdk9_2: 'Facebook',
    sdk9_3: '第三方登录',
    sdk9_4: '操作系统信息、设备型号信息、剪切板信息（适用于iOS）、内存卡权限（适用于Android）、应用列表信息。',
    sdk9_5: '暂无协议',
    sdk10_1: '腾讯开放平台SDK',
    sdk10_2: '深圳市腾讯计算机系统有限公司',
    sdk10_3: '网页浏览，设备登录',
    sdk10_4:
        '设备信息（如IMEI、IMSI、SIM卡序列号、MAC、Android ID）、网络信息以及地理位置信息，获取正在运行的进程、存储权限。',
    sdk11_1: 'com.tencent.connect',
    sdk11_2: '深圳市腾讯计算机系统有限公司',
    sdk11_3: 'APP前台运行时，获取已安装APP信息',
    // eslint-disable-next-line
    sdk11_4:
        '产品安全保障功能：为了保障您的账号安全和系统安全，我们需要获取您的设备MAC地址、IMSI、Android ID、IP地址、硬件型号、操作系统版本号、唯一设备标识符（IMEI等）、网络设备硬件地址（MAC）、软件版本号、网络接入方式、类型、状态、网络质量数据、操作日志、硬件序列号、服务日志信息，收集运行中的进程，已安装应用列表等行为。',
    // sdk 列表 e

    // 权限清单 s
    vvflyJurisdictionList: '云中飞睡眠权限清单',
    // orderNumber 序号
    jurisdictionName: '权限名称',
    functionDescription: '功能描述',
    sceneAndObjective: '使用场景与目的',
    appPlatform: '适用平台',
    jur1_1: 'READ_PHONE_STATE ' + '读取手机/电话状态',
    jur1_2: '允许程序访问电话状态，获取唯一设备识别码（android_id、Mac地址、IMEI、IMSI,SIM卡序列号）等设备识别的信息及本机号码，请您放心该权限无法监听、获取您的任何通话内容与信息',
    jur1_3: '读取设备通话状态和识别码，识别手机设备ID，保证运营商网络免流服务，用于完成音视频、信息展示、账号登录、安全保障等主要功能',
    jur_update_1_1: 'READ_PHONE_STATE ' + '读取手机/电话状态',
    jur_update_1_2:
        '允许程序访问电话状态，获取唯一设备识别码（android_id、Mac地址、IMEI、IMSI,SIM卡序列号）等设备识别的信息及本机号码，请您放心该权限无法监听、获取您的任何通话内容与信息',
    /* eslint-disable */
    jur_update_1_3:
        '读取设备通话状态和识别码，识别手机设备ID，保证运营商网络免流服务，用于完成音视频、信息展示、账号登录、安全保障等主要功能',
    androidAndIos: 'Android/ios',
    jur2_1: '读取/写入位置存储',
    jur2_2: '读取和写入设备存储空间内的数据',
    jur2_3: '缓存数据、图片',
    jur3_1: '悬浮窗权限',
    jur3_2: '允许应用以小窗形式展示',
    jur3_3: '观看视频切换页面时，弹框',
    android: 'Android',
    jur4_1: '位置权限',
    jur4_2: '通过GPS或网络位置信息（例如基站和WLAN）获取设备所在的地理位置信息',
    jur4_3: '用于蓝牙连接设备记录止鼾数据进行位置标记',
    jur5_1: '麦克风权限',
    jur5_2: '使用麦克风记录用户晚上打鼾音频',
    jur5_3: '记录仪功能以记录形式对用户晚上打鼾声音进行记录分析',
    jur6_1: '通知权限',
    jur6_2: '想用户发送通知',
    jur6_3: '消息推送和提醒',
    jur7_1: '蓝牙服务',
    jur7_2: '允许使用蓝牙服务',
    jur7_3: '用于连接止鼾器系统产品',
    jur8_1: '网络权限',
    jur8_2: '允许APP通过移动网络或者WIFI来请求网络',
    jur8_3: '请求网络',
    jur9_1: '前台服务',
    jur9_2: '允许前台服务',
    jur9_3: '实时监测设备监测睡眠使用',
    jur10_1: '完全的互联网访问权限',
    jur10_2: '完全的互联网访问权限',
    jur10_3: '请求网络',
    // 权限清单 e

    // 呼啦圈 --------------------------------s
    // 隐私首页-s
    hlqHomeH1: '【阅读提示】',
    hlqHomeH2: '感谢您使用呼噜圈呼吸监测！',
    hlqHomeH3:
        '我们以概要的形式向您直观说明我们如何处理和保护您的个人信息，我们按照产品功能和使用场景梳理、归类了个人信息收集和使用情况，点击以下链接可了解相关信息说明：',
    hlqHomeH3LinkInfo: '《已收集个人信息清单》',
    hlqHomeH3LinkSDK: '《第三方SDK列表》',
    hlqHomeH3LinkJurisdiction: '《应用权限说明》',
    hlqAgreement: '呼噜圈呼吸监测隐私协议',
    hlqAgreement0_1:
        '我们深知个人信息对您的重要性，也感谢您对我们的信任。我们将通过本政策向您说明我们会如何收集、存储、保护、使用及对外提供您的信息，并说明您享有的权利，其中要点如下：',
    hlqAgreement0_2:
        '为了让您便于了解您在使用我们的产品和/或服务时，我们需要收集的信息类型与用途，我们将结合具体产品和/或服务向您说明。',
    hlqAgreement0_3: '为了向您提供服务所需，我们会按照合法、正当、必要的原则收集您的信息。',
    hlqAgreement0_4:
        '如果为了向您提供服务而需要将您的信息与第三方共享，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意或确认第三方已经征得您的同意。',
    hlqAgreement0_5:
        '如果为了向您提供服务而需要从第三方获取您的信息，我们将要求第三方说明信息来源，并要求第三方保障其提供信息的合法性。',
    hlqAgreement0_6:
        '如果我们将信息用于本政策未载明的其他用途、将基于特定目的收集而来的信息用于其他目的时，或我们开展业务需进行的个人信息处理行为超出您原本向第三方提供个人信息时的授权范围，会事先征求您的明确同意。',
    hlqAgreement0_7:
        '您可以通过本政策介绍的方式访问和管理您的信息、设置功能、注销帐号或进行投诉举报。',
    hlqAgreement0_8: '您可以根据以下索引阅读相应章节，进一步了解本政策的具体内容：',
    hlqAgreement1: '一、引言',
    hlqAgreement2: '二、我们如何收集和使用您的个人信息',
    hlqAgreement3: '三、我们如何访问和管理自己的信息',
    hlqAgreement4: '四、信息披露',
    hlqAgreement5: '五、我们如何使用信息和保护您的信息安全',
    hlqAgreement6: '六、我们如何使用COOKIES或同类技术',
    hlqAgreement7: '七、我们如何保护未成年人的个人信息',
    hlqAgreement8: '八、第三方SDK所收集的信息',
    hlqAgreement9: '九、账号注销',
    hlqAgreement10: '十、本隐私政策的更改',
    hlqAgreement11: '十一、联系、投诉及举报',
    hlqHContent1_0_1:
        '呼噜圈呼吸监测App是由深圳市云中飞电子有限公司（以下简称“呼噜圈”或称“我们”）为您提供的一款智能睡眠监测服务产品。我们深知个人信息对您的重要性，您的信任对我们非常重要，我们将根据相关法律法规要求并参照行业最佳实践为您的个人信息安全提供充分保障。为此，我们制定本《隐私政策》（下称“本政策”）以帮助您充分了解，在您使用呼噜圈的产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息以及您可以如何管理您的个人信息。',
    hlqHContent1_0_2:
        '在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，确保您充分理解和同意后再开始使用，如果您不同意本政策，您应立即停止使用我们提供的产品或服务。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。',
    hlqHContent2_1:
        '1.我们依据法律法规以及遵循正当、合法、必要的原则而收集和使用您在使用服务过程中主动提供或由于产品或服务需要而产生的个人信息。如果我们欲将您的个人信息用于本隐私政策未载明的其它用途，或基于特定目的将收集而来的信息用于其他目的，我们会及时以合理的方式向您告知，并在使用前再次征得您的同意。',
    hlqHContent2_2:
        '2.我们产品与/或服务的核心业务功能所必需的信息：此类信息为产品与/或服务正常运行的必备信息，您须授权我们收集。如您拒绝提供，您将无法正常使用我们的产品与/或服务。',
    hlqHContent2_3: '3.注册账号',
    hlqHContent2_3_1:
        '1）当您注册呼噜圈账号时，会向我们提供手机号码、验证码。当您使用第三方账号登录时，我们会读取您在第三方账号注册使用的昵称、头像。目前我们支持手机号码、QQ、微信、AppleID、Facebook、邮箱登录方式，后续注册登录方式如有变化，以我们实际提供的为准。',
    hlqHContent2_3_2:
        '2）在您注册我们账号时，我们收集您的账户昵称、性别、出生日期、身高、体重、手机号码、验证码匹配结果、邮箱、您在呼噜圈自行设置的邮箱密码等信息。您应悉知，手机号码和验证码匹配结果属于您的个人敏感信息，我们手机该类信息是为了满足相关法律法规的要求，如您拒绝可能导致您无法使用我们的此功能。',
    hlqHContent2_3_3:
        '3）若您以第三方平台的账号（微信账号、AppleID登录，Facebook）登录我们，我们会向第三方请求获取您的个人信息（包括：用户名、账号昵称、头像、手机号码，具体以您授权内容为准）我们还会收集您的国际移动用户识别码IMSI、Android ID用于判断您上次登录呼噜圈的方式，目的是方便您使用一键登录功能。如果您不提供这些信息，则您无法注册/登录我们产品，且无法使用需注册/登录的功能，但不会影响您正常使用无需注册/登录的功能。',
    hlqHContent2_3_4:
        '4）为实现本平台的基本业务功能 ，如手机号码、第三方注册登录我们使用了MobTech短信/认证等服务，此产品的隐私策略条款，可以参考：http://www.mob.com/about/policy',
    hlqHContent2_4: '4.设备信息',
    hlqHContent2_4_0:
        '我们会收集您访问我们的服务所使用的设备的信息，包括：硬件和软件信息，例如：IP 地址、设备 ID 和类型、特定设备和应用程序设置和特征、应用程序崩溃、广告 ID（例如 Google 的 AAID 和 Apple 的 IDFA，它们都是随机生成的数字，您可以通过您设备的设置功能进行重置）、浏览器类型、版本和语言、操作系统、时区、与 cookie 或其他可以确定您的具体设备或浏览器的技术相关的标识符（例如，IMEI/UDID 和 MAC 地址等信息）。当您使用我们的服务或查看由我们提供的内容时我们会自动收集某些信息并存储在日志中，如服务的访问时间、访问次数、访问ip、事件信息（如错误、崩溃、重启、升级）等。',
    hlqHContent_up_2_4_1:
        '1）我们会收集您访问我们的服务所使用的设备的信息，包括：硬件和软件信息，例如：IP 地址、设备 ID 和类型、特定设备和应用程序设置和特征、应用程序崩溃、广告 ID（例如 Google 的 AAID 和 Apple 的 IDFA，它们都是随机生成的数字，您可以通过您设备的设置功能进行重置）、浏览器类型、版本和语言、操作系统、时区、与 cookie 或其他可以确定您的具体设备或浏览器的技术相关的标识符（例如，IMEI/UDID 和 MAC 地址等信息）。当您使用我们的服务或查看由我们提供的内容时我们会自动收集某些信息并存储在日志中，如服务的访问时间、访问次数、访问ip、事件信息（如错误、崩溃、重启、升级）等。',
    hlqHContent_up_2_4_2: '2）获得您同意后的地理位置信息。',
    hlqHContent_up_2_4_3:
        '3）获得您同意后的设备信息，包括设备品牌、设备型号、设备操作系统及版本号、分辨率、像素密度、运营商、唯一设备识别码IDFA(本项仅限iOS系统开发)、MAC地址、GPS地理位置或IP地址(在您未开启GPS地理位置授权时，我们会通过您的IP地址以及利用traceroute跟踪您的IP节点以获取您的所在城市（此项仅限iOS系统开发)）、唯一设备识别码IMEI）。',
    hlqHContent_up_2_4_4: '4）我们需要获取您当前的设备联网状态及网络环境，包括wifi和非wifi。',
    hlqHContent2_5: '5.产品使用信息',
    hlqHContent2_5_1:
        '1）当您选择通过呼噜圈生成数据时，我们将收集与您的睡眠习惯有关的数据，这些数据也可能包含您的个人数据（是否吸烟、是否饮酒、饮食偏好、工作类型），可做为呼噜圈 和睡眠呼吸研究的使用情况。',
    hlqHContent2_5_2:
        '2）您存储在服务器的内容。如您上传到云空间的内容会存储在数据服务提供方服务器，以实现您快速访问和同一内容在不同设备间的共享。我们或合作方不会查看您存储在合作方服务器的内容，我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。',
    hlqHContent2_6: '6.功能点及其对应权限',
    hlqHContent2_6_1:
        '1）睡眠呼吸监测时需要用到存储读写权限、位置信息（网络定位）和精准位置（GPS）信息。当您通过蓝牙连接智能设备如（睡眠监测仪）时，可能需要您授权使用位置信息，以保证您的手机可以快速和智能设备配对并连接成功。',
    hlqHContent2_6_2:
        '2）相机和相册权限：当您设置您的个人头像的时候，需要您授权使用您的相机相册权限，用来拍摄头像或者是在相册中选择图片。',
    hlqHContent2_6_3:
        '3）联系人信息：当您搜索添加好友的时候，您可以授权使用您的联系人信息，方便您快速找到自己的好友。如果您拒绝我们收集关于联系人的信息，我们将不会收集这一信息。',
    hlqHContent2_6_4: '4）网络信息：您的无线和移动网络连接的信息，例如您的服务提供商和信号强度。',
    hlqHContent2_6_5:
        '5）设备传感器信息：为了保证记录仪功能的准确性，需要授权使用设备传感器的基本数据信息，如加速度计等传感器信息。',
    hlqHContent2_6_6: '6）读取/写入存储',
    hlqHContent2_6_6_0_1: '在您睡眠监测过程中，需要将监测的睡眠文件写入到您的手机存储中。',
    hlqHContent2_6_6_0_2: '如您拒绝提供上述权限将可能导致您无法使用我们的产品、技术及/或服务。',
    hlqHContent2_7:
        '7.为提高您使用我们提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防因钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入、违法违规内容而产生的安全风险，更准确地识别违反法律法规或我们制定的相关协议规则的情况，我们可能使用或整合您的账号信息、设备信息、位置信息、日志信息、安装的应用列表以及我们取得您授权或依据法律共享的信息，来综合判断您账号及交易风险、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。',
    hlqHContent2_7_1:
        '1)设备信息: ' +
        '您的设备及软件相关信息，例如您的设备品牌及型号、IP地址、设备软件版本信息、设备识别码（IMEI/MAC地址/Android ID/OPENUDID、SIM卡IMSI信息、OAID）、位置信息、网络使用习惯、硬件序列号ESN。',
    hlqHContent2_7_2:
        '2)日志信息: ' +
        '当您使用我们的产品和/或服务时，我们会收集您对我们服务的详细使用情况，作为有关网络日志保存，包括：IP地址、浏览器的类型、访问的社交媒体页面url地址、访问日期和时间、系统的错误日志及您访问的网页记录。',
    hlqHContent3_1:
        '1.呼噜圈收集的有关您的信息和资料将保存在呼噜圈 及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或呼噜圈收集信息和资料所在地的境外并在境外被访问、存储和展示。',
    hlqHContent3_2:
        '2.呼噜圈帐号均有安全保护功能，请妥善保管您的用户名及密码信息。呼噜圈将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。',
    hlqHContent3_3:
        '3.在使用我们的网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是呼噜圈App的用户名及密码发生泄露，请您立即联络呼噜圈客服，以便呼噜圈 采取相应措施。',
    hlqHContent3_4:
        '4.我们会对员工进行数据安全的意识培养和安全能力的培训和考核，加强员工对于保护个人信息重要性的认识。我们会对处理个人信息的员工进行身份认证及权限控制，并会与接触您个人信息的员工签署保密协议，明确岗位职责及行为准则，确保只有授权人员才可访问个人信息。对于违规员工，我们会严格按照公司内部管理制度及相关法律法规规定追究法律责任。',
    hlqHContent3_5_0_1:
        '5.您可以通过手机“设置”-“应用信息”“呼噜圈”-“权限”选择禁止地理位置权限、蓝牙权限、相机权限、相册权限、麦克风权限、悬浮窗权限、存储权限、电话权限（此项仅限Android系统开发），以此来撤回您的授权。',
    hlqHContent3_5_0_2:
        '请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务和功能，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。',
    hlqHContent3_6:
        '6.如您需要获取您向我们提供的个人信息以及我们通过本政策约定收集您的个人信息，请您通过本政策列明的联系方式与我们取得联系并提出此项需求，我们将在15个工作日内处理您的请求。',
    hlqHContent4_0:
        '在如下情况下，呼噜圈将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：',
    hlqHContent4_1: '1.经您事先同意，向第三方披露；',
    hlqHContent4_2: '2.为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；',
    hlqHContent4_3:
        '3.根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；',
    hlqHContent4_4:
        '4.如您出现违反中国有关法律、法规或者呼噜圈 服务协议或相关规则的情况，需要向第三方披露；',
    hlqHContent4_5:
        '5.如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；',
    hlqHContent4_6:
        '6.在呼噜圈应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，呼噜圈有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。',
    hlqHContent4_7: '7.其它呼噜圈根据法律、法规或者网站政策认为合适的披露。',
    hlqHContent5_0:
        'Cookie和同类技术是互联网中普遍使用的技术。当您使用呼噜圈呼吸监测及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符、缓存，以收集和存储您访问、使用本产品时的信息。我们承诺不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie、缓存和同类技术主要为了实现以下功能或服务：',
    hlqHContent5_1:
        '1、我们可能会使用Cookie和缓存技术存储您的登录状态和基本信息作为其他功能的基础，以避免重复手动登录，减少服务请求。',
    hlqHContent5_2:
        '2、我们可能会使用Cookie和缓存技术对图片、音频等多媒体资源文件进行预加载和缓存，以减少网络资源浪费，同时提升您的用户体验。',
    hlqHContent6_1:
        '1.我们使用您的信息的主要原因是提供和改进我们的服务。此外，我们会使用您的信息来帮助您保持安全。管理您的帐户并向您提供我们的服务，分析您的个人资料和其他用户的个人资料，帮助您更好的使用我们的产品服务。',
    hlqHContent6_2:
        '2.您在使用过程中可以连接您使用的我们多个产品设备，以便您可以在所有设备上享受一致的服务体验。我们实现这一点的方式是当您在不同设备登录帐户时连接设备和浏览器数据，或使用部分或全部 IP 地址、浏览器版本或关于您的设备的类似数据，以识别和连接不同设备。',
    hlqHContent6_3:
        '3.改善我们的服务并开发新服务，对用户行为进行研究和分析，以改善我们的服务和内容（例如，我们可能决定根据用户的行为改变外观和感觉，甚至大幅度修改特定功能）开发新的功能和服务（例如，我们可能决定针对用户提出的请求创建新的基于兴趣的功能）。',
    hlqHContent6_4:
        '4.防止、检测和打击欺诈或其他非法或未经授权的活动.处理平台上下正在进行或涉嫌的违规行为，进行数据分析以更好地理解和设计针对这些活动的对策，保留与欺诈活动相关的数据以防止再次发生欺诈，确保符合法律，遵守法律要求，协助执法，执行或行使我们的权利，在大多数情况下，我们处理您的信息的原因是执行您与我们签订的合同。例如，在您使用我们的服务建立有意义的联系时，我们会使用您的信息来维护您的帐户和个人资料，以便其他用户可以看到您的信息和向您推荐其他用户。',
    hlqHContent6_5:
        '5.我们可以在我们有相应合法利益的情况下使用您的信息。例如，我们为不断改进我们的服务而分析用户使用我们的服务的行为，我们建议我们认为您可能会感兴趣的活动，以及我们出于管理、欺诈检测和其他合法目的处理信息。',
    hlqHContent6_6:
        '6.我们努力保护您的个人信息免遭未经授权的访问或更改、泄露或破坏。和所有技术公司一样，虽然我们采取措施保护您的信息，但我们不能保证、您也不能期望您的个人信息始终是安全的。我们会定期监控我们的系统以发现可能存在的漏洞和攻击，并定期审核我们的信息收集、存储和处理做法，以更新我们的物理、技术和组织安全措施。如果我们怀疑或发现任何破坏安全的行为，我们可能会不经通知暂停您使用全部或部分服务的权利。',
    hlqHContent7_1:
        '1. 根据现行有效的法律法规等相关规定，我们将不满14周岁的未成年人均视为儿童。如您为14周岁以下未成年人，请您的父母或监护人阅读本政策，并在征得您父母或监护人同意的前提下使用我们的服务或向我们提供您的信息。',
    hlqHContent7_2:
        '2.如您的父母或监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。',
    hlqHContent7_3:
        '3.对于我们提供的儿童成长记录等涉及儿童个人信息的功能或服务，需经父母或监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童的权益所必要的情况下使用或公开披露此信息。',
    hlqHContent7_4:
        '4.如果我们发现存在未事先获得可证实的父母或监护人同意的情况下收集了儿童的个人信息，则会尽快删除或匿名化处理相关数据。',
    hlqHContent7_5:
        '5.若您是未成年人的父母或监护人，当您对您所监护的未成年人使用我们的产品和或服务或其向我们提供的信息有任何疑问时，请您及时与我们联系，我们将根据国家相关法律法规及本政策的规定保护未成年人的信息。',
    hlqHContent8_0:
        '我们会向您告知共享的目的、数据接收方的合法性、并事先征得您的同意。准确记录和保存您个人信息的共享的情况，包括共享的日期、规模、目的，以及数据接收方的基本情况。',
    hlqHContent8_1: '1. 我们不会与其他任何公司、组织和个人共享您的个人信息，但以下情况除外：',
    hlqHContent8_1_1: '（1）事先获得您明确的同意或授权；',
    hlqHContent8_1_2:
        '（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；',
    hlqHContent8_1_3:
        '（3）在法律法规允许的范围内，为维护呼噜圈、呼噜圈的关联方或合作伙伴、您或其他呼噜圈用户或社会公众利益、财产或安全免遭损害而有必要提供；',
    hlqHContent8_1_4: '（4）应您需求为您处理您与他人的纠纷或争议；',
    hlqHContent8_1_5: '（5）基于学术研究而使用；',
    hlqHContent8_2:
        '2.当您使用我们的功能或服务时，在某些特定使用场景下，可能会使用具有相应业务资质及能力的第三方服务商提供的软件服务工具包（简称“SDK”）来为您提供服务，有第三方服务商收集您的必要信息。具体包括以下几种：',
    hlqHContent8_2_1: '（1）友盟SDK',
    hlqHContent8_2_1_0_1: '功能：用于统计、分析数据，提供基础反作弊能力、设备应用性能监控服务',
    hlqHContent8_2_1_0_2:
        '收集个人信息类型或权限：设备信息及粗略位置（IMEI/MAC地址/Android ID/IDFA/OpenUDID/SIM卡IMSI/IP）、手机状态权限、SDK/API/JS代码版本、浏览器、互联网服务提供商、平台、时间戳、应用程序版本、应用分发渠道、设备型号、传感器参数、终端制造厂商、终端设备操作系统版本、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等、获取运行中的进程信息。',
    hlqHContent8_2_1_0_3: 'SDK主体：友盟同欣（北京）科技有限公司',
    hlqHContent8_2_1_0_4: 'https://www.umeng.com/page/policy',
    hlqHContent8_2_2: '(2)极光推送 SDK',
    hlqHContent8_2_2_0_1: '功能：消息推送服务,分享',
    hlqHContent8_2_2_0_2:
        '收集个人信息类型或权限：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM 卡 IMSI 信息等）网络信息与位置信息（IP地址，WiFi信息，基站信息等相关信息）',
    hlqHContent8_2_2_0_3: 'SDK主体：深圳市和讯华谷信息技术有限公司',
    hlqHContent8_2_2_0_4: 'https://www.jiguang.cn/license/privacy',
    hlqHContent8_2_3: '（3）微信SDK',
    hlqHContent8_2_3_0_1: '功能：第三方登录、分享',
    hlqHContent8_2_3_0_2:
        '收集个人信息类型或权限：服务日志信息、设备信息（包括设备型号、操作系统版本、唯一设备标识符（IMEI、MAC、Android ID、IDFA（iOS独有）、电池、信号强度信息）、软件信息（包括安装应用列表、软件的版本号、浏览器类型）、IP地址、位置信息（基于iOS系统还会通过IP地址、GPS、WLAN（如WIFI）或基站。等途径获取地理位置信息）、用户在分享时主动选择的图片或内容、微信头像、昵称信息。',
    hlqHContent8_2_3_0_3: 'SDK主体：深圳市腾讯计算机系统有限公司',
    hlqHContent8_2_3_0_4:
        'https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy',
    hlqHContent8_2_4: '（4）QQSDK',
    hlqHContent8_2_4_0_1: '功能：第三方登录、分享',
    hlqHContent8_2_4_0_2:
        '收集个人信息类型或权限：操作系统信息、设备型号信息、剪切板信息（适用于iOS）、内存卡权限（适用于Android）、应用列表信息。',
    hlqHContent8_2_4_0_3: 'SDK主体：深圳市腾讯计算机系统有限公司',
    hlqHContent8_2_4_0_4:
        'https://wiki.connect.qq.com/qq%E4%BA%92%E8%81%94sdk%E9%9A%90%E7%A7%81%E4%BF%9D%E6%8A%A4%E5%A3%B0%E6%98%8E',
    hlqHContent8_2_5: '（5）BuglySDK',
    hlqHContent8_2_5_0_1: '功能：收集闪退信息，判断、收集、统计crash信息',
    hlqHContent8_2_5_0_2:
        '收集个人信息类型或权限：日志信息（包括第三方开发者自定义日志、Logcat日志以及APP崩溃堆栈信息）、设备ID（包括Android ID,Open UDID,MAC,IMEI）、iOS广告标识符（IDFA）、终端设备操作系统版本、终端制造厂商、联网信息、系统名称、系统版本以及国家码。',
    hlqHContent8_2_5_0_3: 'SDK主体：深圳市腾讯计算机系统有限公司',
    hlqHContent8_2_5_0_4:
        'https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56',
    hlqHContent8_2_6: '（6）阿里云OSS对象存储SDK',
    hlqHContent8_2_6_0_1: '功能：上传图片、缓存数据',
    hlqHContent8_2_6_0_2:
        '收集个人信息类型或权限：允许联网、获取网络状态、判断网络状态、获取本地存储。',
    hlqHContent8_2_6_0_3: 'SDK主体：北京阿里巴巴云计算计算有限公司',
    hlqHContent8_2_6_0_4:
        'http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.26104712.J_9220772140.82.1b234373s9nrSI',
    hlqHContent8_2_7: '（7）高德地图',
    hlqHContent8_2_7_0_1: '功能：获取定位',
    hlqHContent8_2_7_0_2:
        '收集个人信息类型或权限：硬件型号、操作系统版本、设备配置、唯一设备标识符（IMEI、Android ID、OPENUDID、GUID、OAID、MEID）、硬件序列号、网络设备硬件地址MAC、设备连接信息以及设备状态信息、网络身份标识信息，广告标识符IDFA (iOS14.5及以上不收集IDFA）、IP地址、位置信息、定位权限（获取动态位置信息（IP地址、卫星信号、及能够提供相关信息的其他传感器（如可能会为高德提供附近设备、WLAN接入点和基站的信息）））、硬件序列号及其他设备相关信息）、应用信息（应用崩溃信息、通知开关状态、应用安装列表及其他应用相关信息）、设备网络环境信息（IP地址、WiFi信息，基站信息及其他网络相关信息）、IMSI。',
    hlqHContent8_2_7_0_3: 'SDK主体：高德软件有限公司',
    hlqHContent8_2_7_0_4: 'https://developer.amap.com/news/privacy_adjustment',
    hlqHContent8_2_8: '（8）ShareSDK',
    hlqHContent8_2_8_0_1: '功能：社交分享',
    hlqHContent8_2_8_0_2:
        '收集个人信息类型或权限：系统运行信息、网络状态信息、iOS广告标识符（IDFA）、国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI）、应用列表信息、基站信息、社交平台OpenID、地理位置',
    hlqHContent8_2_8_0_3: 'SDK主体：上海游昆信息技术有限公司',
    hlqHContent8_2_8_0_4: 'https://www.mob.com/about/policy',
    hlqHContent8_2_9: '（9）Facebook Common Android SDK',
    hlqHContent8_2_9_0_1: '功能：第三方登录',
    hlqHContent8_2_9_0_2:
        '收集个人信息类型或权限：操作系统信息、设备型号信息、剪切板信息（适用于iOS）、内存卡权限（适用于Android）、应用列表信息。',
    hlqHContent8_2_9_0_3: 'SDK主体：Facebook',
    hlqHContent8_2_9_0_4: '暂无协议',
    hlqHContent8_2_10: '（10）腾讯开放平台SDK',
    hlqHContent8_2_10_0_1: '功能：APP前台运行时，获取SIM序列号',
    hlqHContent8_2_10_0_2:
        '收集个人信息类型或权限：用于提供手机号码登录服务。采集地理位置甄别分享通道，提供反作弊服务。采集设备标识符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM卡序列号)以及手机号码',
    hlqHContent8_2_10_0_3: 'SDK主体：腾讯开放平台SDK',
    hlqHContent8_2_10_0_4: 'https://privacy.qq.com/policy/tencent-privacypolicy',
    hlqHContent8_2_11: '（11）com.tencent.connect',
    hlqHContent8_2_11_0_1: ' 功能：APP前台运行时，获取已安装APP信息',
    hlqHContent8_2_11_0_2:
        '收集个人信息类型或权限：为了保障您的账号安全和系统安全，我们需要获取您的设备MAC地址、IMSI、Android ID、IP地址、硬件型号、操作系统版本号、唯一设备标识符（IMEI等）、网络设备硬件地址（MAC）、软件版本号、网络接入方式、类型、状态、网络质量数据、操作日志、硬件序列号、服务日志信息，收集运行中的进程，已安装应用列表等行为。',
    hlqHContent8_2_11_0_3: ' SDK主体：com.tencent.connect',
    hlqHContent8_2_11_0_4: 'https://privacy.qq.com/policy/tencent-privacypolicy',
    hlqHContent9_0:
        '您可以自主要求（我- 账号与安全 - 注销账号）注销账号。在您注销您的账号之前，我们将验证您的个人身份、安全状态、常用设备等信息。您注销账号的行为是不可逆的行为，一旦您注销您的账号，我们将不再收集您的个人信息，并即刻删除有关您账户的一切信息或使其匿名化处理，并保证这些信息不会泄露，同时，您也无法通过已注销的账户获得我们产品的服务。',
    hlqHContent10_1:
        '1.如果决定更改隐私政策，我们会在本政策中、本公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。',
    hlqHContent10_2:
        '2.本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。',
    hlqHContent11_1:
        '1.如果您在使用呼噜圈产品/服务过程中发现您的信息被用于违法行为或受到侵害，欢迎您进行积极举报，我们将按照《中华人民共和国网络安全法》、《个人信息保护法》等法律的要求受理，您需提供合法有效的权利证明、侵权事实、身份证明等文件以供我们核实，我们将在15个工作日内回复您处理结果，您还可以向网信部门、工信部门、公安及工商等监管部门进行投诉或举报。举报途径如下：',
    hlqHContent11_1_1: '(1)客服电话 400-805-8192',
    hlqHContent11_1_2: '(2)举报邮箱：fly@vvfly.cn',
    hlqHContent11_1_3: '(3)登录深圳市云中飞电子有限公司官网 https://www.vvfly.cn与我们联系。',
    hlqHStatement1: '本声明自更新之日起生效',
    hlqHStatement2: '深圳市南山区科技南十二路长虹科技大厦2103-04',
    hlqHStatement3: '深圳市云中飞电子有限公司',
    hlqHStatement4: '最近的更新日期：2022年 10月 13日',
    // 隐私首页-e
    // 个人信息清单-s
    hlqInfoList: '呼噜圈呼吸监测个人信息清单',
    hlqInfoList1: '登录注册',
    hlqInfoList1_1_1: '通过手机号登录/注册',
    hlqInfoList1_1_2: '验证身份',
    hlqInfoList1_1_3: '手机号码',
    hlqInfoList1_2_1: '通过邮箱登录/注册',
    hlqInfoList1_2_3: '邮箱',
    hlqInfoList1_3_1: '通过微信登录/注册',
    hlqInfoList1_3_3:
        '微信账号、昵称、头像、性别、所在国家、省市信息（请以授权登录界面显示的信息未准）',
    hlqInfoList1_4_1: '通过QQ登录/注册',
    hlqInfoList1_4_3:
        'QQ账号、昵称、头像、性别、所在国家、省市信息（请以授权登录界面显示的信息未准）',
    hlqInfoList1_5_1: '通过AppleID登录/注册',
    hlqInfoList1_5_3:
        'Apple ID、昵称、头像、性别、所在国家、省市信息（请以授权登录界面显示的信息未准）',
    hlqInfoList1_6_1: 'Facebook ID 登录/注册',
    hlqInfoList1_6_3:
        'Facebook ID、昵称、头像、性别、所在国家、省市信息（请以授权登录界面显示的信息未准）',
    hlqInfoList1_7_1: '游客登录',
    hlqInfoList1_7_3: '国际移动用户识别码IMSI、Android ID',
    hlqInfoList2: '账号信息',
    hlqInfoList2_1_1: '账号信息',
    hlqInfoList2_1_2: '睡眠习惯预测，根据用户生活习惯评估用户使用设备后的建议意见；',
    hlqInfoList2_1_3: '昵称、性别、出生日期、身高、体重',
    hlqInfoList2_2_1: '生活习惯',
    hlqInfoList2_2_3: '是否吸烟、是否饮酒、饮食偏好、工作类型（久坐、久站、重体力工作、其他）',
    hlqInfoList2_3_1: '通知提醒设置',
    hlqInfoList2_3_2: '及时收到推送消息及提醒（用户互动通知、闹钟提醒、上新活动推送等）',
    hlqInfoList2_3_3: '通知权限',
    hlqInfoList3: '呼吸监测',
    hlqInfoList3_1_1: '实时睡眠监测功能',
    hlqInfoList3_1_2: '连接并使用睡眠呼吸监测设备',
    hlqInfoList3_1_3: '蓝牙权限、位置权限、存储权限',
    hlqInfoList3_2_1: '报告',
    hlqInfoList3_2_2: '生成睡眠呼吸报告，分享睡眠报告',
    hlqInfoList3_2_3: '蓝牙权限，分享数据（第三方微信、朋友圈、QQ,Facebook）',
    hlqInfoList3_3_1: '数据缓存',
    hlqInfoList3_3_2: '快速访问',
    hlqInfoList3_3_3: '数据权限',
    hlqInfoList4_0_1: '调用终端设备信息',
    hlqInfoList4_0_2: '保障设备安全',
    hlqInfoList4_0_3:
        '设备信息：设备品牌及型号、IP地址、设备软件版本信息、电话权限（获取IMEI）、设备识别码(MAC/Android ID/OPENUDID、SIM卡IMSI信息、OAID)、位置信息、硬件序列号ESN。 ' +
        ' 日志信息：搜索查询内容（如搜索词语）、IP地址、浏览器的类型、访问的社交媒体页面url地址、访问日期和时间、系统的错误日志及您访问的网页记录',
    hlqInfoList5_0_1: '调用设备信息',
    hlqInfoList5_0_2: '验证身份，账号安全登录',
    hlqInfoList5_0_3:
        '登录时我们还需要收集您的 硬件序列号、唯一设备识别码（android_id、Mac地址、IMEI、IMSI,SIM卡序列号） ，为了保障软件与服务的安全运行、运营的质量及效率，我们会收集你的设备的硬件型号、操作系统版本号、设备标识符（Android如IMEI、AndroidID、OAID、IMSI、ICCID、MEID、硬件序列号）、网络设备硬件地址（MAC地址）、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、设备传感器数据。',
    hlqInfoList6_0_1: 'APP前台运行时',
    hlqInfoList6_0_2: 'SIM卡序列号',
    hlqInfoList6_0_3:
        '在您注册/登录账户时，您需要提供 手机号码及验证码 ，使用App服务时，您需提供 手机号码 作为账户登录名，登录时我们还需要收集您的 硬件序列号、唯一设备识别码（android_id、Mac地址、IMEI、IMSI,SIM卡序列号） 以验证账号及密码并完成登录；如您拒绝提供 手机号码、验证码及密码 个人信息，则可能无法成功注册/登录App账户。',
    // 个人信息清单-e
    // sdk 列表 -s  和云中飞睡眠一致 复用
    hlqSdkList: '呼噜圈呼吸监测第三方SDK列表',
    // sdk 列表 -e
    // 呼啦圈权限清单-s
    hlqJurList: '呼噜圈呼吸监测权限清单',
    hlqJur1_1: 'READ_PHONE_STATE \n' + '读取手机/电话状态',
    hlqJur1_2:
        '允许程序访问电话状态，获取唯一设备识别码（android_id、Mac地址、IMEI、IMSI,SIM卡序列号）等设备识别的信息及本机号码，请您放心该权限无法监听、获取您的任何通话内容与信息',
    hlqJur1_3:
        '读取设备通话状态和识别码，识别手机设备ID，保证运营商网络免流服务，用于完成音视频、信息展示、账号登录、安全保障等主要功能',
    hlqJur2_1: '读取/写入位置存储',
    hlqJur2_2: '读取和写入设备存储空间内的数据',
    hlqJur2_3: '缓存数据、图片',
    hlqJur3_1: '悬浮窗权限',
    hlqJur3_2: '允许应用以小窗形式展示',
    hlqJur3_3: '观看视频切换页面时，弹框',
    hlqJur4_1: '位置权限',
    hlqJur4_2: '通过GPS或网络位置信息（例如基站和WLAN）获取设备所在的地理位置信息',
    hlqJur4_3: '用于蓝牙连接设备记录呼吸检测数据进行位置标记',
    hlqJur5_1: '通知权限',
    hlqJur5_2: '想用户发送通知',
    hlqJur5_3: '消息推送和提醒',
    hlqJur6_1: '蓝牙服务',
    hlqJur6_2: '允许使用蓝牙服务',
    hlqJur6_3: '用于连接呼噜圈呼吸监测产品',
    hlqJur7_1: '网络权限',
    hlqJur7_2: '允许APP通过移动网络或者WIFI来请求网络',
    hlqJur7_3: '请求网络',
    hlqJur8_1: '前台服务',
    hlqJur8_2: '允许前台服务',
    hlqJur8_3: '实时监测设备监测睡眠使用',
    hlqJur9_1: '完全的互联网访问权限',
    hlqJur9_2: '完全的互联网访问权限',
    hlqJur9_3: '请求网络',
    // 呼啦圈权限清单-e
    // 呼啦圈 --------------------------------e
};

export default zhCh;
